import { makeStyles } from "@material-ui/styles";

export const useServiceStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    iconStyle: { fontSize: "12px", padding: "0px" },
    SearchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    searchPaper: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: 400,
    },
    table: {
      minWidth: 960,
      marginTop: "1em"
    },
    serviceHeading: {
      fontSize: "20px",
      fontWeight: "bold"
    },
    serviceCards: {
      backgroundColor: "rgb(239 239 239)",
      marginTop: "2em"
    },
    switchLabels: {
      fontSize: "15px",
      paddingTop: "8px"
    },
    accordionStyle: {
      backgroundColor: "#3d5a79",
      color: "white"
    },
    tableMessage:{
      color:"black",
      fontWeight:"bold",
      fontSize:"1.3em",
      textAlign:"right",
      paddingLeft:"5em"
    },
  })
);
